import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://iijqpznihnlpmsjtboyq.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlpanFwem5paG5scG1zanRib3lxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU2OTA5MTEsImV4cCI6MjA3MTI2NjkxMX0.Tf7IhhZHcAEIuIVJyJk4TnGYII-7PccCPvRU0ILkY_c'

export const supabase = createClient(supabaseUrl, supabaseKey, {
  db: {
    schema: 'api'
  },
  global: {
    fetch: window.fetch
  }
})